import { Injectable } from '@angular/core';
import { ToastController,LoadingController ,AlertController} from '@ionic/angular';

import { messages } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  private loading;
  constructor(
    private toasCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl:AlertController) { }

  async viewMessageAlertAuthentication(callback,email) {
    const alert = await this.alertCtrl.create({
      header: 'Envio de autenticación!',
      message: '¿Quieres reenviar la confirmación al correo ' + email + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'violet',
        }, {
          text: 'Si',
          handler: () => {
            callback.createLinkAuthentication({'email':email}).then(data=>{
              this.viewMessageToastControllerSuccess(data.message)
            },error =>{
              if((error.status >= 500 && error.status <= 511) || error.status == 0){
                this.viewMessageToastControllerError(messages.problemasConexion)
              }else{
                this.viewMessageToastControllerError(error.error.message)
              }
            });

            // callback.createLinkAuthentication({'email':email}).then(data=>{
            //   this.viewMessageToastControllerSuccess(data.message)
            // },error =>{
            //   console.log(error)
            //   this.viewMessageToastControllerError(messages.problemasConexion)
            // });

          }
        }
      ]
    });

    alert.present();
  }

  async viewMessageAlertDone(message) {
    const alert = await this.alertCtrl.create({
      header: 'Confirmación de registro',
      subHeader: 'Envío de correo',
      message: message,
        buttons: ['OK']
    });

    alert.present();
  }

  async viewMessageToastController(message:string){
    const toast = await this.toasCtrl.create({
      message: message, duration: 5000
    })
    toast.present();
  }

  async viewMessageToastControllerSuccess(message:string){
    const toast = await this.toasCtrl.create({
      message: message, duration: 5000,
      color:"success"
    })
    toast.present();
  }

  async viewMessageToastControllerError(message:string){
    const toast = await this.toasCtrl.create({
      message: message, duration: 5000,
      color:"danger"
    })
    toast.present();
  }

  async viewMessageToastControllerWarning(message:string){
    const toast = await this.toasCtrl.create({
      message: message, duration: 5000,
      color:"warning"
    })
    toast.present();
  }

  async viewPresentLoading(){
    return await this.loadingCtrl.create({
      message: 'Espere un momento...',
      spinner: 'bubbles',
      cssClass: 'custom-loader-class'
    })
  }

  async viewPresentLoadingFiltro(){
    return await this.loadingCtrl.create({
      spinner: 'bubbles',
      cssClass:"message"
    })
  }



}
